import React from 'react'
import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import caseIcon from "../assets/icons/case.svg";
import { Trans } from "react-i18next";
import "react-medium-image-zoom/dist/styles.css";
import word from "../assets/image/logoIMG/word.png";
import excel from "../assets/image/logoIMG/excel.png";
import ppt from "../assets/image/logoIMG/ppt.png";
import foxit from "../assets/image/logoIMG/foxit.png";
import acrobat from "../assets/image/logoIMG/acrobat.png";

const UseCase = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-19";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return "";
    }
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          max-w-3xl
        "
            >
                <div className="
  relative flex items-center justify-between gap-3
  mobile:flex-col
  mobile:items-stretch
  desktop:flex-row-reverse
  tabletpro:flex-row-reverse
  tabletair:flex-row-reverse
  tabletmini:flex-row-reverse
  mini_mobile:flex-col mini_mobile:items-stretch
">
                    {/* Copy button */}
                    <div className="mobile:flex mobile:justify-end mobile:order-1 mini_mobile:flex mini_mobile:justify-end">
                        <CopyButton text={buildCopyText(t)} />
                    </div>

                    {/* Icon + text */}
                    <div className="flex items-center gap-1 mobile:order-2">
                        <img
                            src={caseIcon}
                            alt="case"
                            className="w-9 h-16 mobile:w-9 mobile:h-9"
                        />
                        <p className="text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[28px] mobile:text-[28px] mini_mobile:text-[24px] font-semibold">
                            {t("sidebar.cases.title")}
                        </p>
                    </div>
                </div>


                <div className="mt-2 relative">
                    <section className='flex flex-col gap-4 mt-1'>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="useCase.title"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="useCase.des"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <section className="mt-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 text-center">
                            {/* Word */}
                            <div className="flex flex-col items-center gap-2">
                                <img src={word} alt="word" className="w-12 h-12 object-contain" />
                                <p className="text-sm text-gray-600 dark:text-gray-300">
                                    {t("useCase.word")}
                                </p>
                            </div>

                            {/* Excel */}
                            <div className="flex flex-col items-center gap-2">
                                <img src={excel} alt="excel" className="w-12 h-12 object-contain" />
                                <p className="text-sm text-gray-600 dark:text-gray-300">
                                    {t("useCase.excel")}
                                </p>
                            </div>

                            {/* PowerPoint */}
                            <div className="flex flex-col items-center gap-2">
                                <img src={ppt} alt="ppt" className="w-12 h-12 object-contain" />
                                <p className="text-sm text-gray-600 dark:text-gray-300">
                                    {t("useCase.ppt")}
                                </p>
                            </div>

                            {/* Foxit */}
                            <div className="flex flex-col items-center gap-2">
                                <img src={foxit} alt="foxit" className="w-12 h-12 object-contain" />
                                <p className="text-sm text-gray-600 dark:text-gray-300">
                                    {t("useCase.foxit")}
                                </p>
                            </div>

                            {/* Acrobat */}
                            <div className="flex flex-col items-center gap-2">
                                <img src={acrobat} alt="acrobat" className="w-12 h-12 object-contain" />
                                <p className="text-sm text-gray-600 dark:text-gray-300">
                                    {t("useCase.acrobat")}
                                </p>
                            </div>
                        </section>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.usage.supportedSign")}
                            to="/supported-sign"
                        />
                        <NextSectionCard
                            label={t("sidebar.cases.word")}
                            to="/cases/word"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default UseCase